module dg.objects {

    function wysiwygDisplayer(): ng.IDirective {
        return {
            restrict: 'A',
            scope: {
                value: '<'
            },
            template: '<div ng-bind-html="value"></div>'
        };
    }

    angular.module('dg.objects')
        .directive('wysiwygDisplayer', wysiwygDisplayer);
}